/** @file TODO: documentar */
import onmount from 'onmount';
import { loadCKeditor } from './load';

// La opción onlyText habilita solo las opciones de edicion de texto simple.
// La opción onlyNotify habilita solo las opciones para basicas para envio de notificaciones
// Quita opciones de tabla, html e imágenes.
export const EDITOR_OPTIONS = (isMailerTemplate = true, onlyText = false, onlyNotify = false,
  textAndLinks = false, videoLinks = false) => {
  const options = {
    shiftMode: CKEDITOR.ENTER_BR,
    base64image: { allow_remote: false },
    disallowedContent: 'img{width,height,float}',
    extraAllowedContent: 'img[width,height,align]',
    extraPlugins: 'tableresize,templates,base64image,copyformatting,colorbutton,justify,pagebreak',
    height: isMailerTemplate ? 200 : 800,
    contentsCss: isMailerTemplate ? ['https://cdn.ckeditor.com/4.7.3/full-all/contents.css'] :
      ['https://cdn.ckeditor.com/4.7.3/full-all/contents.css', '/document_editor.css'],
    bodyClass: isMailerTemplate ? 'mailer-editor' : 'document-editor',
    format_tags: 'p;h1;h2;h3;pre',
    removeDialogTabs: 'image:advanced;link:advanced',
    stylesSet: [
      /* Inline Styles */
      { name: 'Marker', element: 'span', attributes: { 'class': 'marker' } },
      { name: 'Cited Work', element: 'cite' },
      { name: 'Inline Quotation', element: 'q' },
      /* Object Styles */
      {
        name: 'Special Container',
        element: 'div',
        styles: {
          padding: '5px 10px',
          background: '#eee',
          border: '1px solid #ccc',
        },
      },
      {
        name: 'Compact table',
        element: 'table',
        attributes: {
          cellpadding: '5',
          cellspacing: '0',
          border: '1',
          bordercolor: '#ccc',
        },
        styles: {
          'border-collapse': 'collapse',
        },
      },
      {
        name: 'Borderless Table', element: 'table',
        styles: { 'border-style': 'hidden', 'background-color': '#E6E6FA' },
      },
      { name: 'Square Bulleted List', element: 'ul', styles: { 'list-style-type': 'square' } },
    ],
  };

  let toolbar;
  if (onlyText) {
    toolbar = [
      { name: 'clipboard', items: ['Undo', 'Redo'] },
      { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] },
      { name: 'colors', items: ['TextColor', 'BGColor'] },
    ];
  }
  else if(onlyNotify) {
    toolbar = [
      { name: 'basicstyles', items: ['Bold', 'Italic', 'Strike'] },
      { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
      { name: 'styles', items: ['Format'] },
    ];
  }
  else if(textAndLinks) {
    toolbar = [
      { name: 'basicstyles', items: ['Bold', 'Italic', 'Strike'] },
      { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
      { name: 'styles', items: ['Format'] },
      { name: 'links', items: ['Link', 'Unlink'] },
    ];
  }
  else {
    toolbar = [
      { name: 'clipboard', items: ['Undo', 'Redo', 'Source'] },
      { name: 'styles', items: ['Format'] },
      { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] },
      { name: 'colors', items: ['TextColor', 'BGColor'] },
      { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
      { name: 'links', items: ['Link', 'Unlink'] },
      { name: 'insert', items: ['Table', 'PageBreak', 'base64image'] },
      { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
      { name: 'tools', items: ['Maximize'] },
      { name: 'editing', items: ['Scayt'] },
    ];
  }
  if (videoLinks) {
    CKEDITOR.plugins.addExternal('youtube', '');
    options.extraPlugins += ',youtube';
    options.youtube_disabled_fields = ['chkAutoplay', 'chkResponsive'];
    options.youtube_responsive = true;
    for (let i = 0; i < toolbar.length; i++) {
      if (toolbar[i].name === 'insert') {
        toolbar[i].items.push('Youtube');
        break;
      }
      else if (i === toolbar.length - 1) {
        toolbar.push({ name: 'insert', items: ['Youtube'] });
      }
    }
  }
  options.toolbar = toolbar;
  options.removeButtons = '';
  return options;
};

onmount('[data-ck-editor]', async function (input) {
  await loadCKeditor();

  // Esta opción habilita opciones de edicion de texto simple.
  // Esta opción onlyNotify habilita la opciones basica para notificaciones
  // Quita opciones de tabla, html e imagenes

  const onlyText = $(this).data('ckOnlyTxt');
  const onlyNotify = $(this).data('ckOnlyNotify');
  const textAndLinks = $(this).data('ckTextAndLinks');
  const videoLinks = $(this).data('ckVideoLinks');
  input.editor = CKEDITOR.replace(this, EDITOR_OPTIONS(true, onlyText, onlyNotify, textAndLinks, videoLinks));
});
